/* eslint-disable react-hooks/exhaustive-deps */
import {useState, useEffect} from "react"
import {useTranslation} from "react-i18next"
import {Descendant} from "slate"
import {BaseInput} from "components/inputs"
import {INITIAL_RTE_CONTENT, isEmptyContent} from "components/RichTextEditor/slate-custom-types"
import {EmailTemplate, TemplateType} from "types/settings/email-template"
import styles from "./TemplateSelection.module.css"
import {MessageTemplateSelect} from "components/MessageTemplateSelect"

type Props = {
    withEmail: boolean
    withSMS: boolean
    setValue: Function
    selectedTemplate
    setSelectedTemplate: Function
    descendants: Descendant[]
    setDescendants: Function
    setSubject: Function
    subject: string
    selectedUserId?: number
    serializeWithoutUser: boolean
}

export function TemplateSelection(props: Props) {
    const {
        withEmail,
        withSMS,
        setValue,
        selectedTemplate,
        setSelectedTemplate,
        descendants,
        setDescendants,
        setSubject,
        subject,
        selectedUserId,
        serializeWithoutUser
    } = props

    const {t} = useTranslation(["chat", "common"])
    const [templateTypes, setTemplateTypes] = useState<string[]>([])

    useEffect(() => {
        let _templateTypes: string[] = []
        if (withEmail) {
            _templateTypes.push(TemplateType.Email)
        }
        if (withSMS) {
            _templateTypes.push(TemplateType.SMS)
        }
        setTemplateTypes(_templateTypes)
    }, [withEmail, withSMS])

    useEffect(() => {
        if ((withEmail || withSMS) && (selectedUserId || serializeWithoutUser)) {
            isEmptyContent(descendants) ? setValue("") : setValue("SHOULD_SERIALIZE_DATA_BEFORE_SENDING")
        }
    }, [withEmail, withSMS, selectedUserId, serializeWithoutUser, JSON.stringify(descendants)])

    const onChangeTemplate = (option?: EmailTemplate) => {
        let newDescendants = option?.template ? JSON.parse(option.template) : INITIAL_RTE_CONTENT
        const newSubject: string = option?.template ? option.subject || "" : ""

        newDescendants = newDescendants.map(normalizeDescendants).filter((el) => el)

        setDescendants(newDescendants)
        setSubject(newSubject)
        setSelectedTemplate(option)
    }

    const normalizeDescendants = (node) => {
        if (node?.children?.length) {
            node.children = node.children.map(normalizeDescendants).filter((el) => el)
        }
        return node
    }

    return (
        <>
            {(withEmail || withSMS) && (
                <>
                    <div className={styles.subjectWrapper}>
                        <label>{t("chat.selectTemplate")}</label>
                        <MessageTemplateSelect
                            value={selectedTemplate}
                            onChange={onChangeTemplate}
                            templateTypes={templateTypes}
                            showGroup={true}
                            className={styles.subjectWrapperDropdown}
                            enabled={(withEmail || withSMS) && templateTypes.length > 0}
                        />
                    </div>
                    {withEmail && (
                        <div className={styles.subjectWrapper}>
                            <label>{t("chat.emailSubject")}</label>
                            <BaseInput value={subject} onChange={setSubject} />
                        </div>
                    )}
                </>
            )}
        </>
    )
}
